<script>
export default {
    props: {
        header: Object,
        value: { type: [String, Number, Boolean, File, Date, Array, Object], default: undefined },
    }

}
</script>
<template>
    <core-field
        style="width: 100px;"
        select
        :field="{
            value: header.value,
            text: header.text,
            id: header.id,
            filter: header.filter,
            list: header.list,
            reference: header.reference,
            title: header.title,
            subtitle: header.subtitle,
            type: 'autocomplete',
            placeholder: 'Select',
            full: true,
        }"
        :value="value"
        @input="v => $emit('input', v)"
    />
</template>